import store from "../store/store"
import config from "../common/config";
import CryptoJS from "crypto-js"
import crypto from "crypto"
import Api from './Api'
import Vue from 'vue'
import router from '../router/index'

const ToastTabError = { theme: 'toasted-primary', icon: 'warning', position: 'top-center', duration: 4000, fitToScreen: true, type: 'error' }

export default function getOrabank(montant_ttc, modePaiement) {
    if (typeof store.state.devispayement !== 'undefined' && store.state.devispayement !== null && store.state.user && store.state.user !== null) {
        config.Orabank.params.amount.value = Number(montant_ttc);

        let numeroDevis = format_devis_if_avenant(store.state.devispayement.devis) 
        let codePartenaire = store.state.code_partenaire;
        config.Orabank.params.merchantOrderReference = codePartenaire + "-" + numeroDevis;
        const params = encrypt(config.Orabank.params);
        Api().post(config.Orabank.url, params).then((result) => {
            window.open(result.data._links.payment.href)
            setTimeout(() => { router.go(router.push('/payment/orabankrep')) }, 70000);
        }).catch((err) => {
            Vue.toasted.show('Erreur de connexion serveur d\'orabank ! ', ToastTabError)
            console.log(err)
        });
    }
}
function format_devis_if_avenant(devis){
    if (devis.last_avenant != undefined && devis.last_avenant != "" && !devis.numeroDevis.includes(devis.last_avenant)) {
        return devis.numeroDevis + "/" + devis.last_avenant
    }
    return devis.numeroDevis
}

function rewriteText(text) {
    if (text == "Santé") {
        return "Sante"
    } else {
        return text
    }
}

function encrypt(body) {
    const passphrase = getCodeSecret(32);
    const encrypt = cryptoJSAesEncrypt(passphrase, body)
    const data = {
        element0: encrypt.ciphertext,
        element1: encrypt.salt,
        element2: encrypt.iv,
        element3: passphrase,
    }
    return data;

}

function getCodeSecret(lenght) {
    const rand = crypto.randomBytes(lenght);
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let code = '';
    for (let i = 0; i < rand.length; i++) {
        let index = rand[i] % chars.length;
        code += chars[index];
    }
    return code;
}

function cryptoJSAesEncrypt(passphrase, element) {

    console.log("==============================")
    console.log("devis", element)

    if (typeof element === 'object') {
        element = JSON.stringify(element)
    }
    let salt = CryptoJS.lib.WordArray.random(256);
    let iv = CryptoJS.lib.WordArray.random(16);
    let key = CryptoJS.PBKDF2(passphrase, salt, { hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999 });
    let encrypted = CryptoJS.AES.encrypt(element, key, { iv: iv });

    let data = {
        ciphertext: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
        salt: CryptoJS.enc.Hex.stringify(salt),
        iv: CryptoJS.enc.Hex.stringify(iv)
    }

    return data;
}